const AppConfig = {
  warehouse_failure_redirect_uri: window.env.WAREHOUSES_URL,
  warehouses_url: window.env.WAREHOUSES_URL,
};

export { AppConfig };
